import * as React from 'react';

import {Illustration} from 'shells/illustrations/illustration';

import type {EntityType} from 'nutshell-graphql-types';
import type {
    EmailMembershipStatsFragment as MembershipStats,
    SmsMembershipStatsFragment as SmsMembershipStats,
} from 'nutshell-graphql-types';

import {AudienceSelector} from './audience-selector';
import {ChooseRecipientType} from './choose-recipient-type';
import {SavedListSelector} from './saved-list-selector';

import styles from './new-recipients-selection-view.module.css';

type Props = {
    selectedRecipients: SelectedRecipients | null | undefined;
    setSelectedRecipients: (arg1: SelectedRecipients) => void;
    canAccessFullCampaigns: boolean;
    useSmsStats?: boolean;
};

export const RECIPIENT_TYPE_AUDIENCE = 'audience';
export const RECIPIENT_TYPE_SAVED_LIST = 'list';

export type AudienceRecipientSelection = {
    id: string;
    name: string;
    htmlUrlPath: string;
    recipientCount: number;
    unsubscribedRate?: number | null | undefined;
    membershipStats?: MembershipStats;
    smsMembershipStats?: SmsMembershipStats;
};

export type ListRecipientSelection = {
    id: string;
    name: string;
    htmlUrlPath: string;
    filterString: string;
    entityType: EntityType;
    recipientCount: number;
};

export type SelectedRecipients =
    | {
          type: 'audience';
          recipientSelection?: AudienceRecipientSelection;
      }
    | {
          type: 'list';
          recipientSelection?: ListRecipientSelection;
      };

export function NewRecipientsSelectionView(props: Props) {
    const currentSelection = props.selectedRecipients;

    return (
        <div className={styles.container}>
            <>
                <ChooseRecipientType
                    onSelect={(type) => props.setSelectedRecipients({type: type})}
                    currentSelection={currentSelection ? currentSelection.type : null}
                    canAccessAudiences={props.canAccessFullCampaigns}
                />
                <div className={styles['right-container']}>
                    {currentSelection && currentSelection.type === RECIPIENT_TYPE_AUDIENCE ? (
                        <AudienceSelector
                            selectedRecipients={currentSelection.recipientSelection}
                            setSelectedRecipients={(
                                selectedRecipients?: AudienceRecipientSelection | null
                            ) => {
                                props.setSelectedRecipients({
                                    type: RECIPIENT_TYPE_AUDIENCE,
                                    recipientSelection: selectedRecipients
                                        ? selectedRecipients
                                        : undefined,
                                });
                            }}
                            canAccessAudiences={props.canAccessFullCampaigns}
                            useSmsStats={props.useSmsStats}
                        />
                    ) : undefined}
                    {currentSelection && currentSelection.type === RECIPIENT_TYPE_SAVED_LIST ? (
                        <SavedListSelector
                            selectedRecipients={currentSelection.recipientSelection}
                            setSelectedRecipients={(
                                selectedRecipients?: ListRecipientSelection | null
                            ) => {
                                props.setSelectedRecipients({
                                    type: RECIPIENT_TYPE_SAVED_LIST,
                                    recipientSelection: selectedRecipients
                                        ? selectedRecipients
                                        : undefined,
                                });
                            }}
                        />
                    ) : undefined}
                    {!currentSelection ? (
                        <div className={styles.background}>
                            <Illustration src='audience' />
                            <div className={styles.description}>
                                Choose who you would like to send to
                            </div>
                        </div>
                    ) : undefined}
                </div>
            </>
        </div>
    );
}
